import styled from "styled-components";

export const SectionSeparator = styled.div`
    display: flex;
    height: 1px;
    background-color: ${props => props.theme.colors.secondary};
    margin: 10px 0;
`
